// extracted by mini-css-extract-plugin
module.exports = {"text":"DecoderText_text__AkruT","glyph":"DecoderText_glyph__wKKhR","value":"DecoderText_value__iQEKN"};